import React, { useState } from 'react';

interface BqTabItemProps {
  label: string;
  index: number;
  children: React.ReactNode;
}

export const BqTabItem: React.FC<BqTabItemProps> = ({ children }) => {
  return <div>{children}</div>;
};

interface TabsProps {
  defaultIndex?: number;
  onTabClick?: (index: number) => void;
  children: React.ReactNode;
}

export const BqTabs = ({
  defaultIndex = 1,
  onTabClick,
  children,
}: TabsProps) => {
  const [bindIndex, setBindIndex] = useState(defaultIndex);

  const changeTab = (newIndex: React.SetStateAction<number>) => {
    if (typeof onTabClick === 'function') onTabClick(Number(newIndex));
    setBindIndex(newIndex);
  };

  const items = React.Children.toArray(children).filter(
    (item: any) => React.isValidElement(item) && item.type === BqTabItem,
  );

  return (
    <>
      <div
        className="flex p-ai-center p-1 mt-3 "
        style={{
          // backgroundColor: '#f1f5f9',
          backgroundColor: 'var(--bq-color-gray-light2)',
          borderRadius: '8px',
        }}
      >
        {items.map((item) => {
          if (React.isValidElement(item)) {
            const { index, label } = item.props as {
              index: number;
              label: string;
            };
            return (
              <div
                key={index}
                className={`py-2 px-3 text-sm ${
                  bindIndex === index
                    ? 'text-bold border-round'
                    : 'text-secondary'
                }`}
                style={{
                  color:
                    bindIndex === index
                      ? 'var(--bq-color-black)'
                      : 'var(--light-text)',
                  cursor: 'pointer',
                  backgroundColor:
                    bindIndex === index
                      ? 'var(--bq-color-white)'
                      : 'transparent',
                  boxShadow:
                    bindIndex === index
                      ? '0 1px 2px rgba(0, 0, 0, 0.1)'
                      : 'none',
                }}
                onClick={() => changeTab(index)}
              >
                {label}
              </div>
            );
          }
          return null;
        })}
      </div>
      <div className="tab-view">
        {items.map((item) => {
          if (React.isValidElement(item)) {
            const { index } = item.props as { index: number };
            return (
              <div
                {...item.props}
                className={bindIndex === index ? 'block' : 'hidden'}
                key={index}
              >
                {item.props.children}
              </div>
            );
          }
          return null;
        })}
      </div>
    </>
  );
};
